<template>
  <v-app>
    <v-app-bar app elevation="0" style="background: none" class="g-d-sm-none">
      <v-avatar tile class="mr-2"><img :src="require('@/assets/logo.png')" alt="数智残联" /></v-avatar>
      <v-toolbar-title class="blue--text g_size-28 font-weight-bold">{{ $vtk.env.VUE_APP_HEAD }}</v-toolbar-title>
    </v-app-bar>
    <v-main class="accent_bg bg-sm">
      <v-container fill-height class="mx-auto" style="height: calc(100% - 200px)">
        <v-form ref="users" v-model="valid" :model="users" class="text-center m-t-sm-0 mx-auto">
          <v-card width="1200" elevation="2" class="py-6 d-inline-block m-t-sm-0">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="left_bg rounded-bl-lg rounded-tl-lg display-sm-none" style="min-height: 500px"></v-col>
              <v-col cols="12" sm="6" md="6" class="g_px-20 p-lr-sm-6 py-12 rounded-br-lg rounded-tr-lg" style="min-height: 500px">
                <v-tabs v-model="tabsidx" show-arrows>
                  <v-tabs-slider color="primary"></v-tabs-slider>
                  <v-tab class="px-0 mr-6 g_size-16">员工登录</v-tab>
                  <v-tab class="px-0 mr-6 g_size-16">法人登录</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabsidx" class="bg-sm-color-none">
                  <v-tab-item class="pt-8" style="height: 300px">
                    <v-text-field v-model="users.telephone" placeholder="手机号" prepend-inner-icon="mdi-cellphone" outlined :rules="rules.mobile"></v-text-field>
                    <v-text-field v-model="users.mcode" placeholder="验证码" prepend-inner-icon="mdi-numeric" outlined :rules="rules.code">
                      <template v-slot:append>
                        <a @click="mcode()" style="margin-top: 3px" :class="canClick ? '' : 'grey--text'">{{ content }}</a>
                      </template>
                    </v-text-field>
                    <v-card-actions class="px-0 d-block">
                      <v-btn color="primary" depressed block large :loading="loading" @click="submit('sms')">登录</v-btn>
                    </v-card-actions>
                  </v-tab-item>
                  <v-tab-item class="pt-8 login-gl text-left height-100 pl-8">
                    <p class="display-1 mt-2">法人登录</p>
                    <p class="grey--text my-2">使用政务服务网账号登录</p>
                    <v-btn class="mt-12" elevation="0" rounded style="min-width: 180px" color="primary" large :loading="loading" :href="$vtk.env.VUE_APP_LOGIN">去登录</v-btn>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-container>
    </v-main>
    <v-footer class="copyright d-md-inline-block text-center pb-12 pt-4 g-d-sm-none">
      {{ $vtk.env.VUE_APP_FOOT }}
      <a href="https://pc.qq.com/category/c3.html" class="text-right pr-6">
        我们推荐您使用Chrome，获得最佳体验
        <p class="title mb-0"><v-icon size="40" class="mr-1" color="primary">mdi-google-chrome</v-icon>Chrome 浏览器</p>
      </a>
    </v-footer>
    <wtk-message><!--弹出消息区域--></wtk-message>
  </v-app>
</template>

<script>
import Request from "@/commons/request";
import Storage from "@/commons/storage";
import Message from "@/components/message";
import Validation from "@/commons/validation";
export default {
  name: "AdminLogin",
  data() {
    return {
      users: {},
      tabsidx: "", //选项卡序号
      loading: false, // 加载中进度条
      showpass: false, // 是否明文显示
      content: "获取验证码",
      totalTime: 120,
      canClick: true,
      valid: true,
      rules: {
        idCard: [(val) => !!val || "请填写身份证号码/手机号"],
        password: [(val) => !!val || "请填写密码"],
        mobile: [(val) => Validation.isMobile(val) || "请填写正确的手机号码格式"],
        code: [(val) => (!!val && val.length == "6") || "请填写六位数验证码"],
      },
    };
  },
  created() {
    Storage.remove("_wit_acis_token"); //自动退出
    Storage.remove("_wit_acis_users"); //清理用户
    Storage.clear(); //清除所有缓存
  },
  methods: {
    mcode() {
      if (!this.users.telephone || !Validation.isMobile(this.users.telephone)) {
        Message.toast("手机号码格式错误！", { color: "error" });
        return;
      }
      if (!this.canClick) return; //阻止重复点击
      this.canClick = false;
      this.content = this.totalTime + "秒后重试";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "秒后重试";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.content = "重新获取验证码";
          this.totalTime = 120;
          this.canClick = true; //重新开始
        }
      }, 1000);
      Message.loading.show();
      Request.postForm("/unia/admin/mcode", { mobile: this.users.telephone }).then(
        (res) => {
          Message.loading.hide();
          if (res.meta.success) {
            this.users.ticket = res.data.ticket;
            Message.toast("短信验证码发送成功，请注意查收！");
          } else {
            Message.toast(res.meta.message, { color: "red" });
          }
        },
        (err) => {
          console.log(err);
          Message.loading.hide();
        }
      );
    },
    submit(type) {
      if (this.$refs.users.validate()) {
        this.loading = true;
        Message.loading.show();
        Request.postJson(`/unia/admin/login/${type}`, this.users).then(
          (res) => {
            this.loading = false;
            Message.loading.hide();
            if (res.meta.success) {
              Storage.set("_wit_acis_token", res.data.token); //只用存储token
              this.$router.push("/home");
            } else {
              Message.toast(res.meta.message, { color: "error" });
            }
          },
          (err) => {
            Message.loading.hide();
            console.log(err);
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-gl {
  background-image: url(../../assets/img/login-gl.png);
  background-size: cover;
  background-position: left bottom;
  height: 300px;
}
.accent_bg {
  background-image: url(../../assets/img/login_bg.jpg);
  background-size: cover;
}
.left_bg {
  background-image: url(../../assets/img/login_img.png);
  background-size: contain;
  background-position-x: 50%;
}
.copyright {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.copyright > a {
  position: absolute;
  right: 0;
}
@media screen and (max-width: 500px) {
  .min-width {
    min-width: 0px !important;
    width: 100%;
  }
  .min-height {
    min-height: 360px !important;
  }
  .width-sm-100vw {
    width: 100vw;
  }
  .bg-sm-none {
    background-image: none !important;
    background-size: contain;
  }
  .bg-sm {
    background-image: url(../../assets/img/login_bg2.jpg);
  }
  .bg-sm-color-none {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .theme--dark.v-tabs > .v-tabs-bar {
    background-color: rgba(0, 0, 0, 0) !important;
  }
}
</style>